{
  "assets": {
    "MapIcon": "Icono",
    "Model": "Modelo 3D",
    "none_selected_warning": "Debes tener un {{ assetType }} seleccionado",
    "all_categories": "Todas las categorías",
    "select": "Selecciona {{ assetType }}",
    "search_placeholder": "Busca {{ assetType }}"
  },
  "layerTemplates": {
    "selectTemplateText": "Plantillas de capas de búsqueda",
    "createCustomLayer": "Crea una capa personalizada",
    "startFromScratch": "iniciar una nueva capa desde cero",
    "failedToLoadTemplates": "No se pudieron cargar las plantillas de capas",
    "failedToLoadLayer": "No se pudo cargar la capa",
    "noLayerTemplates": "No podemos encontrar ninguna plantilla con ese nombre. ¿Desea iniciar una nueva capa sin utilizar una plantilla en su lugar?",
    "searchPlaceholder": "Por ejemplo, transporte",
    "allTemplates": "Todas las plantillas",
    "searchResults": "Resultados de la búsqueda"
  },
  "toolbarButtonTooltips": {
    "draw_map_object": "Dibujar",
    "undo": "Deshacer",
    "redo": "Rehacer",
    "copy_map_objects": "Copiar y pegar",
    "draw_analysis_line": "Dibuja una línea",
    "draw_analysis_polygon": "Dibuja un polígono",
    "draw_rectangle": "Dibuja un rectángulo",
    "draw_point": "Dibuja un punto",
    "draw_icon": "Dibujar icono",
    "draw_model": "Dibujar modelo",
    "draw_line_model": "Dibuja un modelo lineal",
    "snapping_tools": "Ajustes de ajuste"
  },
  "sidebarButtonTooltips": {
    "new_layer": "Crea una capa a partir de una plantilla",
    "import_layer": "Importe capas de otros planes",
    "attribute_data_table": "Tabla de datos de atributos",
    "toggle_all_layers_visibility": "Cambia la visibilidad de todas las capas",
    "hide_all_layers": "Oculta todas las capas",
    "show_all_layers": "Mostrar todas las capas",
    "change_log": "Registro de cambios"
  },
  "toggleAllLayersVisibilityConfirmation": {
    "title": "Cambia la visibilidad de todas las capas",
    "message": "Esto cambiará la visibilidad de todas las capas para todos los usuarios. ¿Está seguro de que desea continuar?"
  },
  "layerOptionsTooltips": {
    "layer_information": "Información de capas",
    "layer_view_options": "Opciones de visualización de capas",
    "hide_layer": "Ocultar capa",
    "show_layer": "Mostrar capa"
  },
  "backgroundMapSelector": {
    "background_map_options": "Opciones de fondo",
    "recommended": "Recomendado",
    "configure": "Configurar"
  },
  "sitemaps": {
    "no_sitemaps_available": "No hay mapas del sitio en esta ubicación.\nLos mapas del sitio son mapas detallados de ubicaciones, como dibujos CAD que muestran el diseño interno de un edificio.",
    "no_sitemaps_available_2": "\npara obtener más información sobre cómo agregar mapas de sitio"
  },
  "drawing_tooltips": {
    "title": "Herramientas de dibujo",
    "enter_edit_mode": "Haga clic aquí y, a continuación, haga clic en el mapa para empezar a dibujar",
    "enter_edit_mode_no_layers": "Para empezar a dibujar en el mapa, primero cree (o seleccione) una capa con el panel de la izquierda",
    "enter_composition_part_1": "Haga clic en el mapa para añadir puntos. Haga doble clic o pulse",
    "enter_composition_part_2": "para terminar."
  },
  "search_tooltip": {
    "set_save_title": "¿Establecer esta ubicación como predeterminada para el plan?",
    "set_save_content": "El plan volverá a esta ubicación la próxima vez que lo abras.",
    "set_save_save": "Guardar vista",
    "set_save_dismiss": "Tal vez más tarde",
    "save_info_title": "Vistas guardadas",
    "save_info_content": "Puedes gestionar las vistas guardadas del plan o cambiar las vistas predeterminadas de tu plan desde el menú de búsqueda.",
    "save_info_got_it": "¿Lo tienes"
  },
  "attributes": {
    "allowed_metadata_properties": "Propiedades de metadatos permitidas",
    "required": "Necesario",
    "system_datafield_type": "Tipo de campo de datos del sistema"
  },
  "map_tour": {
    "tip_3_location": {
      "title": "Busque una ubicación",
      "content": "Aquí puedes buscar lugares en el plano, como calles, lugares u objetos que hayas colocado. También puedes guardar ubicaciones importantes para ir a ellas y establecer una ubicación predeterminada para tu plan."
    },
    "tip_4_background": {
      "title": "Elige el fondo de tu mapa",
      "content": "Aquí puedes elegir entre diferentes fondos de mapa, como imágenes de satélite o proveedores de mapas locales. También puedes establecer el fondo predeterminado."
    },
    "tip_5_layer": {
      "title": "Crea tu primera capa",
      "content": "Para empezar a dibujar, crea una nueva capa."
    }
  },
  "zoomableValues": {
    "fixed": "Fijo",
    "by_zoom_level": "Por nivel de zoom",
    "edit_zoom_levels": "Edite los niveles de zoom",
    "predefined": "Predefinidos",
    "custom": "Personalizado",
    "hide": "Esconder",
    "add_zoom_level": "Añadir nuevo nivel de zoom",
    "zoom_options": "Opciones de zoom",
    "zoom_levels": "Niveles de zoom",
    "street_level": "A pie de calle",
    "city_level": "A nivel de ciudad",
    "country_level": "A nivel nacional",
    "world_level": "A nivel mundial",
    "max_level": "Al máximo nivel de zoom"
  },
  "sidebarToolbar": {
    "share": "Comparte el plan"
  },
  "units": {
    "pixels": "Píxeles",
    "degrees": "Grados",
    "scale": "Escala",
    "meters": "Medidores"
  }
}